import React from 'react'

export interface AppRatingContextProps {
  triggerAppRating: () => void
  resetAppRatingTrigger: () => void
  openAppRating: () => void
  openAppRatingTriggered: boolean
  appRatingOpened: boolean
  closeAppRating: () => void
  resetAppRatingDates: () => void
}

/**
 * Context for App Rating
 */
const AppRatingContext = React.createContext<AppRatingContextProps>({
  triggerAppRating: () => undefined,
  resetAppRatingTrigger: () => undefined,
  openAppRating: () => undefined,
  openAppRatingTriggered: false,
  appRatingOpened: false,
  closeAppRating: () => undefined,
  resetAppRatingDates: () => undefined,
})

export default AppRatingContext
